export const coachCategoriesKeys = {
  all: ["coachCategories"] as const,
  list: () => [...coachCategoriesKeys.all, "list"] as const,
  detail: (id: string) => [...coachCategoriesKeys.all, "detail", id] as const,
  slotDefaults: (id: string) => [...coachCategoriesKeys.all, "slotDefaults", id] as const,
}
